import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { NgSignaturePadOptions } from '@almothafar/angular-signature-pad/lib/angular-signature-pad.component';
import { Base64FileData, FilesVisibility, PdDocumentsData } from '../pd-collect-data.store';

@Component({
  selector: 'app-pd-documents',
  templateUrl: './pd-documents.component.html',
})
export class PdDocumentsComponent {
  @Input() visibility!: FilesVisibility;
  @Output() next = new EventEmitter<PdDocumentsData>();
  @Output() back = new EventEmitter<void>();
  @ViewChild(SignaturePadComponent) signature!: SignaturePadComponent;
  public signaturePadOptions: NgSignaturePadOptions = {
    backgroundColor: '#FFF',
    canvasHeight: 200,
    canvasWidth: 300,
  };

  private signatureData?: string;
  private corporateCertificateData?: Base64FileData;
  private accountOwnerIdData?: Base64FileData;
  private bankAccountOwnershipData?: Base64FileData;
  private businessStampData?: Base64FileData;

  public setCorporateCertificate(fileData: Base64FileData) {
    this.corporateCertificateData = fileData;
  }

  public clearCorporateCertificate() {
    this.corporateCertificateData = undefined;
  }

  public setAccountOwnerId(fileData: Base64FileData) {
    this.accountOwnerIdData = fileData;
  }

  public clearAccountOwnerId() {
    this.accountOwnerIdData = undefined;
  }

  public setBankAccountOwnership(fileData: Base64FileData) {
    this.bankAccountOwnershipData = fileData;
  }

  public clearBankAccountOwnership() {
    this.bankAccountOwnershipData = undefined;
  }

  public setBusinessStamp(fileData: Base64FileData) {
    this.businessStampData = fileData;
  }

  public clearBusinessStamp() {
    this.businessStampData = undefined;
  }

  public setSignature() {
    if (this.signature.isEmpty()) {
      this.signatureData = undefined;
    }
    this.signatureData = this.signature.toDataURL();
  }

  public clearSignature(): void {
    this.signature.clear();
    this.signatureData = undefined;
  }

  public get valid(): boolean {
    return (
      !!this.signatureData &&
      !!this.businessStampData &&
      (!this.visibility.corporateCertificate || !!this.corporateCertificateData) &&
      (!this.visibility.accountOwnerId || !!this.accountOwnerIdData) &&
      (!this.visibility.bankAccountOwnership || !!this.bankAccountOwnershipData)
    );
  }

  public submit() {
    if (!this.valid) {
      return;
    }
    this.next.emit({
      signature: this.signatureData!,
      businessStamp: this.businessStampData!,
      corporateCertificate: this.corporateCertificateData,
      accountOwnerId: this.accountOwnerIdData,
      bankAccountOwnership: this.bankAccountOwnershipData,
    });
  }

  public goBack() {
    this.back.emit();
  }
}
